// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const focus: Styleguide["focus"] = {
    // Store Custom Code
    color: "#002A52",
    width: "3px",
};

export default focus;
